import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getAuthUserId } from "@/utils/authUser";
import ChatRoomList from "@/components/chat/ChatRoomList";

/**
 * Student chat list — rooms for the signed-in student, shared with the business
 * portal through `ChatRoomList`.
 */
const StudentChatPage: React.FC = () => {
  const { t } = useTranslation();
  const currentUserId = useSelector((state: any) =>
    getAuthUserId(state.auth),
  );

  return (
    <ChatRoomList
      currentUserId={currentUserId}
      basePath="/student/chat"
      title={t("Chats")}
      emptyMessage={t(
        "Start a chat from your redeemed coupons, sponsors or Settings.",
      )}
      hideRefresh
    />
  );
};

export default StudentChatPage;
